

















import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator'
import { Lov } from '@/models/lov'
import { groupBy, filter, forOwn } from 'lodash'

interface GroupedOpts {
  label: string
  opts: Lov[]
}

@Component({
  components: {}
})
export default class LovSelect extends Vue {

  @Prop({ default: [] })
  public opts!: Lov[]

  @Prop({ default: '' })
  public value!: String

  @Prop({ default: '' })
  public placeholder!: String

  private get _groupedOpts(): GroupedOpts[] {
    const hashed = groupBy(this.opts.filter((o) => o.category), (o) => o.category)
    const out: GroupedOpts[] = []
    forOwn(hashed, (value, key) => {
      out.push({
        label: key,
        opts: value
      })
    })
    return out
  }

  private get _ungroupedOpts(): Lov[] {
    let emptyValue = [new Lov({ id: 'placeholder', type: 'placeholder', value: '' })]
    if (this.value != '' && !this.opts.find((o) => o.value === this.value)) {
      emptyValue.push(new Lov({ id: 'original', type: 'original', value: this.value }))
    }
    return emptyValue.concat(this.opts.filter((o) => !o.category))
  }

  public textFor(lov: Lov) {
    if (lov.type == 'placeholder') {
      return this.placeholder
    }
    // For Old Values
    // if (lov.type == 'original') {
    //   return `OLD: ${this.value}`
    // }
    return lov.value
  }

  public inputEvent(e: any) {
    this.input(e.srcElement.value)
  }

  @Emit()
  public input(value: string) {}
}
